// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
import { TerceraTIFComboBox } from './TerceraTIFComboBox';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class QuickTableTifComboBox extends TerceraTIFComboBox {
    constructor(initProps, data, callback, rect) {
        super();
        const rowData = data.cell.QuickTableEditingInfo.GetDataHandler(data.row);
        const items = [];
        for (let i = 0; i < rowData.items.length; i++) {
            items.push({
                type: NewContextMenuItemType.Default,
                text: rowData.items[i].text,
                value: rowData.items[i].value
            });
        }
        const selectedTif = rowData.selectedValue;
        this._initialTif = selectedTif;
        void super.set({ items });
        super.setItembyValue(selectedTif.type);
        void super.set({ gtdDate: selectedTif.expirationTime });
        this.tag = data;
        this.callBack = callback;
        super.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
        void super.set('isAllowEmpty', true);
        void super.set('isPosAbsolute', true);
        void super.set('hasAdaptiveMenu', true);
    }
    oncomplete() {
        super.oncomplete();
        super.setFocus();
        super.MenuShow();
    }
    onGTDDateChangedFromDropDown(date) {
        super.onGTDDateChangedFromDropDown(date);
        this.lostFocus();
    }
    lostFocus() {
        super.lostFocus();
        const selectedItem = this.get('selectedItem');
        const gtdDate = this.get('gtdDate');
        if (isNullOrUndefined(selectedItem) ||
            (selectedItem.value === this._initialTif.type && gtdDate === this._initialTif.expirationTime) ||
            (selectedItem.value === OrderTif.GTD && isNullOrUndefined(gtdDate))) {
            this.callBack(null, this.tag);
        }
        else {
            this.callBack(new TIF(selectedItem.value, gtdDate), this.tag);
        }
    }
}
TerceraTIFComboBox.extendWith(QuickTableTifComboBox, {
    data: function () {
        return {
            zIndex: 1
        };
    }
});
